<template>
  <div class="extrainfo">
    <!-- 顶部标题栏 -->
    <toptitle :title1="titlework" />

    <!-- 用户信息展示 -->
    <div class="user-info" v-if="userName">
      <span>姓名：{{ userName }}</span>
    </div>

    <!-- 页签折叠面板（默认收起） -->
    <van-collapse v-model="activeNames">
      <!-- 页签1：无离职证明承诺书 -->
      <van-collapse-item
        v-if="visibleTabs.includes('noResign')"
        name="noResign"
        :title="tabMap.noResign"
      >
        <van-cell-group>
          <van-field
            v-model="formNoResign.C_PRE_COMPANY"
            label="上家单位名称"
            placeholder="请输入上家单位名称"
            required
            clearable
          />
          <van-field
            readonly
            clickable
            required
            label="上家单位离职日期"
            placeholder="请选择离职日期"
            :value="formNoResign.C_END_DATE"
            @click="datePicker.show = true"
          />
        </van-cell-group>
      </van-collapse-item>

      <!-- 页签2：化学-入职员工知识产权背景调查及自我声明 -->
      <van-collapse-item
        v-if="visibleTabs.includes('chemical')"
        name="chemical"
        :title="tabMap.chemical"
      >
        <van-cell-group>
          <van-field
            v-model="formChemical.C_YJLY"
            label="研究领域"
            placeholder="请输入研究领域"
            required
            clearable
          />
        </van-cell-group>

        <!-- 历史工作经历（可增删多条） -->
        <div class="sub-block">
          <div class="sub-block-title">
            历史工作经历
            <van-button size="mini" type="info" icon="plus" @click="addWorkHistory">新增</van-button>
          </div>
          <div class="sub-block-item" v-for="(item, index) in formChemical.workHistory" :key="index">
            <div class="sub-block-item-head">
              <span>经历 {{ index + 1 }}</span>
              <van-button v-if="formChemical.workHistory.length > 1" size="mini" type="danger" @click="removeWorkHistory(index)">删除</van-button>
            </div>
            <van-cell-group>
              <van-field
                v-model="item.C_PRE_COMPANY"
                label="曾入职的前单位"
                placeholder="请输入前单位名称"
                required
                clearable
              />
              <van-field
                v-model="item.HR_NAME"
                label="前单位人事联系人"
                placeholder="请输入人事联系人"
                required
                clearable
              />
              <van-field
                v-model="item.HR_PHONE"
                label="联系号码"
                placeholder="请输入联系号码"
                required
                clearable
              />
            </van-cell-group>
          </div>
        </div>

        <van-cell-group>
          <van-field
            v-model="formChemical.DESCRLONG"
            label="知识产权情况介绍"
            type="textarea"
            placeholder="请输入之前工作中涉及的知识产权情况（如专利、专项技术、论文等）"
            required
            rows="2"
            autosize
          />
          <van-field
            readonly
            clickable
            required
            label="与前单位是否存在保密义务？"
            placeholder="请选择"
            :value="ynDisplay(formChemical.C_IS_BMYW)"
            @click="openPicker('formChemical.C_IS_BMYW', '与前单位是否存在保密义务？')"
          />
          <van-field
            readonly
            clickable
            required
            label="是否签署离职后竞业限制条款？"
            placeholder="请选择"
            :value="ynDisplay(formChemical.C_IS_JYXZ)"
            @click="openPicker('formChemical.C_IS_JYXZ', '是否与前单位签署过离职后的竞业限制条款？')"
          />
          <van-field
            readonly
            clickable
            :required="isFieldRequired('formChemical.C_FLAG1')"
            :class="{ 'field-optional': !isFieldRequired('formChemical.C_FLAG1') }"
            :label="depLabel('若有，是否有实际执行？', 'formChemical.C_FLAG1')"
            placeholder="请选择"
            :value="ynDisplay(formChemical.C_FLAG1)"
            @click="openPicker('formChemical.C_FLAG1', '若有，是否有实际执行？')"
          />
          <van-field
            v-model="formChemical.COMMENTS"
            :label="depLabel('执行说明', 'formChemical.COMMENTS')"
            type="textarea"
            placeholder="若有执行，请详细说明"
            :required="isFieldRequired('formChemical.COMMENTS')"
            :class="{ 'field-optional': !isFieldRequired('formChemical.COMMENTS') }"
            rows="2"
            autosize
          />
          <van-field
            readonly
            clickable
            required
            label="是否存在知识产权纠纷？"
            placeholder="请选择"
            :value="ynDisplay(formChemical.C_IS_CZJF)"
            @click="openPicker('formChemical.C_IS_CZJF', '是否与前单位存在发明创造权属纠纷或其他知识产权纠纷？')"
          />
          <van-field
            v-model="formChemical.COMMENTS1"
            :label="depLabel('纠纷说明', 'formChemical.COMMENTS1')"
            type="textarea"
            placeholder="若有纠纷，请详细说明"
            :required="isFieldRequired('formChemical.COMMENTS1')"
            :class="{ 'field-optional': !isFieldRequired('formChemical.COMMENTS1') }"
            rows="2"
            autosize
          />
          <van-field
            readonly
            clickable
            required
            label="是否允许本公司核查？"
            placeholder="请选择"
            :value="ynDisplay(formChemical.C_IS_HCZSCQ)"
            @click="openPicker('formChemical.C_IS_HCZSCQ', '您是否允许本公司在您入职本公司之前向该雇主核查您所提供的知识产权信息？')"
          />
          <van-field
            v-model="formChemical.C_COMMENTS"
            :label="depLabel('不允许原因', 'formChemical.C_COMMENTS')"
            type="textarea"
            placeholder="如果否，请说明原因"
            :required="isFieldRequired('formChemical.C_COMMENTS')"
            :class="{ 'field-optional': !isFieldRequired('formChemical.C_COMMENTS') }"
            rows="2"
            autosize
          />
        </van-cell-group>
      </van-collapse-item>

      <!-- 页签3：TPU-员工入职知识产权背景调查表 -->
      <van-collapse-item
        v-if="visibleTabs.includes('tpu')"
        name="tpu"
        :title="tabMap.tpu"
      >
        <div class="text-tip">知识产权背景调查（是否有知识产权署名）</div>
        <van-cell-group>
          <van-field
            readonly
            clickable
            required
            label="发明专利"
            placeholder="请选择"
            :value="ynDisplay(formTpu.C_IS_FMZL)"
            @click="openPicker('formTpu.C_IS_FMZL', '发明专利')"
          />
          <van-field
            readonly
            clickable
            required
            label="实用新型专利"
            placeholder="请选择"
            :value="ynDisplay(formTpu.C_IS_SYXXZL)"
            @click="openPicker('formTpu.C_IS_SYXXZL', '实用新型专利')"
          />
          <van-field
            readonly
            clickable
            required
            label="外观专利"
            placeholder="请选择"
            :value="ynDisplay(formTpu.C_IS_WGZL)"
            @click="openPicker('formTpu.C_IS_WGZL', '外观专利')"
          />
          <van-field
            readonly
            clickable
            required
            label="是否签署本行业竞业尽职限制协议"
            placeholder="请选择"
            :value="ynDisplay(formTpu.C_IS_JYXZ)"
            @click="openPicker('formTpu.C_IS_JYXZ', '是否签署本行业竞业尽职限制协议')"
          />
          <van-field
            readonly
            clickable
            required
            label="是否发生过知识产权纠纷"
            placeholder="请选择"
            :value="ynDisplay(formTpu.C_IS_CZJF)"
            @click="openPicker('formTpu.C_IS_CZJF', '是否发生过知识产权纠纷')"
          />
        </van-cell-group>
      </van-collapse-item>

      <!-- 页签4：浙江新材料+合成+重庆新材料-入职员工知识产权背景调查表 -->
      <van-collapse-item
        v-if="visibleTabs.includes('zhejiang')"
        name="zhejiang"
        :title="tabMap.zhejiang"
      >
        <van-cell-group>
          <van-field
            v-model="formZhejiang.C_YJLY"
            label="研究领域"
            placeholder="请输入研究领域"
            required
            clearable
          />
          <van-field
            v-model="formZhejiang.C_DESCR"
            label="知识产权数量"
            placeholder="请输入之前工作中涉及的知识产权数量"
            required
            clearable
          />
          <van-field
            v-model="formZhejiang.COMMENTS"
            label="知识产权具体情况"
            type="textarea"
            placeholder="请输入之前工作中涉及的知识产权具体情况"
            required
            rows="2"
            autosize
          />
        </van-cell-group>

        <div class="text-tip">进入本公司前最后一个雇主的详细信息，请填写所有完整信息</div>
        <van-cell-group>
          <van-field
            v-model="formZhejiang.C_PRE_COMPANY"
            label="公司名称"
            placeholder="请输入公司名称"
            required
            clearable
          />
          <van-field
            v-model="formZhejiang.C_COM_XZ"
            label="性质"
            placeholder="请输入公司性质"
            required
            clearable
          />
          <van-field
            v-model="formZhejiang.C_ADDRESS"
            label="公司地址"
            placeholder="请输入公司地址"
            required
            clearable
          />
          <van-field
            readonly
            clickable
            required
            label="起始时间"
            placeholder="请选择起始时间范围"
            :value="formatDateRange()"
            @click="calendar.show = true"
          />
          <van-field
            v-model="formZhejiang.C_PRE_DEPARTMENT"
            label="就职部门"
            placeholder="请输入就职部门"
            required
            clearable
          />
        </van-cell-group>

        <!-- 直接主管相关信息（缩进） -->
        <div class="sub-block">
          <div class="sub-block-title">直接主管相关信息</div>
          <van-cell-group class="indent-block">
            <van-field
              v-model="formZhejiang.NAME1"
              label="姓名"
              placeholder="请输入姓名"
              required
              clearable
            />
            <van-field
              v-model="formZhejiang.DEPTID1_DESCR"
              label="部门"
              placeholder="请输入部门"
              required
              clearable
            />
            <van-field
              v-model="formZhejiang.C_POSITION_DESCR1"
              label="职位"
              placeholder="请输入职位"
              required
              clearable
            />
            <van-field
              v-model="formZhejiang.PHONE1"
              label="电话"
              placeholder="请输入电话"
              required
              clearable
            />
          </van-cell-group>
        </div>

        <!-- 人力资源部门联系人（缩进） -->
        <div class="sub-block">
          <div class="sub-block-title">人力资源部门联系人</div>
          <van-cell-group class="indent-block">
            <van-field
              v-model="formZhejiang.NAME2"
              label="姓名"
              placeholder="请输入姓名"
              required
              clearable
            />
            <van-field
              v-model="formZhejiang.C_POSITION_DESCR2"
              label="职位"
              placeholder="请输入职位"
              required
              clearable
            />
            <van-field
              v-model="formZhejiang.PHONE2"
              label="电话"
              placeholder="请输入电话"
              required
              clearable
            />
          </van-cell-group>
        </div>

        <van-cell-group>
          <van-field
            v-model="formZhejiang.C_TER_REASON"
            label="离职原因"
            type="textarea"
            placeholder="请输入离职原因"
            required
            rows="2"
            autosize
          />
          <van-field
            readonly
            clickable
            required
            label="是否允许本公司核查？"
            placeholder="请选择"
            :value="ynDisplay(formZhejiang.C_IS_HCZSCQ)"
            @click="openPicker('formZhejiang.C_IS_HCZSCQ', '您是否允许本公司在您入职之前向该雇主核查您所提供的知识产权信息？')"
          />
          <van-field
            v-model="formZhejiang.C_COMMENTS"
            :label="depLabel('不允许原因', 'formZhejiang.C_COMMENTS')"
            type="textarea"
            placeholder="如果否，请说明原因"
            :required="isFieldRequired('formZhejiang.C_COMMENTS')"
            :class="{ 'field-optional': !isFieldRequired('formZhejiang.C_COMMENTS') }"
            rows="2"
            autosize
          />
        </van-cell-group>

        <div class="text-tip">你曾经有过以下情形吗？</div>
        <van-cell-group>
          <van-field
            readonly
            clickable
            required
            label="因不正当行为被辞退"
            placeholder="请选择"
            :value="ynDisplay(formZhejiang.C_IS_CT)"
            @click="openPicker('formZhejiang.C_IS_CT', '因为不正当行为或者原因而被辞退')"
          />
          <van-field
            readonly
            clickable
            required
            label="未通过背景调查"
            placeholder="请选择"
            :value="ynDisplay(formZhejiang.C_IS_BJDC)"
            @click="openPicker('formZhejiang.C_IS_BJDC', '未通过背景调查')"
          />
          <van-field
            readonly
            clickable
            required
            label="曾被取消进入公司设施权限"
            placeholder="请选择"
            :value="ynDisplay(formZhejiang.C_IS_QXQX)"
            @click="openPicker('formZhejiang.C_IS_QXQX', '曾被取消进入公司相关设施的权限')"
          />
          <van-field
            v-model="formZhejiang.C_EXPLAIN"
            :label="depLabel('情形解释', 'formZhejiang.C_EXPLAIN')"
            type="textarea"
            placeholder="如果有，请全面解释"
            :required="isFieldRequired('formZhejiang.C_EXPLAIN')"
            :class="{ 'field-optional': !isFieldRequired('formZhejiang.C_EXPLAIN') }"
            rows="2"
            autosize
          />
          <van-field
            readonly
            clickable
            required
            label="是否签订竞业限制协议"
            placeholder="请选择"
            :value="ynDisplay(formZhejiang.C_IS_JYXZ)"
            @click="openPicker('formZhejiang.C_IS_JYXZ', '是否有签订过如竞业限制类的协议')"
          />
          <van-field
            readonly
            clickable
            :required="isFieldRequired('formZhejiang.C_FLAG1')"
            :class="{ 'field-optional': !isFieldRequired('formZhejiang.C_FLAG1') }"
            :label="depLabel('公司是否发放竞业限制补偿金', 'formZhejiang.C_FLAG1')"
            placeholder="请选择"
            :value="ynDisplay(formZhejiang.C_FLAG1)"
            @click="openPicker('formZhejiang.C_FLAG1', '若有，公司是否向您发放竞业限制补偿金')"
          />
          <van-field
            v-if="isFieldRequired('formZhejiang.C_JYXZ_BS')"
            readonly
            clickable
            :required="isFieldRequired('formZhejiang.C_JYXZ_BS')"
            :label="depLabel('补偿金倍数', 'formZhejiang.C_JYXZ_BS')"
            placeholder="请选择补偿金倍数"
            :value="formZhejiang.C_JYXZ_BS"
            @click="openPicker('formZhejiang.C_JYXZ_BS', '竞业限制补偿金倍数', multipleColumns)"
          />
          <van-field
            v-if="formZhejiang.C_JYXZ_BS === '3倍以上'"
            v-model="formZhejiang.C_JT_BS"
            :label="depLabel('具体倍数', 'formZhejiang.C_JT_BS')"
            placeholder='选"3倍以上"的，请写明具体倍数'
            :required="isFieldRequired('formZhejiang.C_JT_BS')"
            clearable
          />
          <van-field
            readonly
            clickable
            required
            label="是否了解其他竞业限制协议"
            placeholder="请选择"
            :value="ynDisplay(formZhejiang.C_IS_YXGZ)"
            @click="openPicker('formZhejiang.C_IS_YXGZ', '你是否了解你和前雇主或者其他公司签订有类似竞业限制协议而可能会影响你在本公司的工作')"
          />
          <van-field
            v-model="formZhejiang.C_XGXZ"
            :label="depLabel('相关限制', 'formZhejiang.C_XGXZ')"
            type="textarea"
            placeholder="如果是，请列出相关限制"
            :required="isFieldRequired('formZhejiang.C_XGXZ')"
            :class="{ 'field-optional': !isFieldRequired('formZhejiang.C_XGXZ') }"
            rows="2"
            autosize
          />
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>

    <!-- 底部保存按钮 -->
    <div class="footer-btn">
      <van-button type="info" block @click="save">保存</van-button>
    </div>

    <!-- 通用选择器弹层（是/否、倍数等复用） -->
    <van-popup v-model="picker.show" round position="bottom">
      <van-picker
        show-toolbar
        :title="picker.title"
        :columns="picker.columns"
        @confirm="onPickerConfirm"
        @cancel="picker.show = false"
      />
    </van-popup>

    <!-- 离职日期选择器 -->
    <van-popup v-model="datePicker.show" round position="bottom">
      <van-datetime-picker
        type="date"
        title="请选择离职日期"
        :max-date="maxDate"
        @confirm="onResignDateConfirm"
        @cancel="datePicker.show = false"
      />
    </van-popup>

    <!-- 起始时间日期范围选择器（不限制历史与未来日期） -->
    <van-calendar
      v-model="calendar.show"
      type="range"
      title="请选择起始时间范围"
      :min-date="calendarMinDate"
      :max-date="calendarMaxDate"
      @confirm="onDateRangeConfirm"
    />
  </div>
</template>

<script>
  import toptitle from '../components/toptitle';
  import isempty from '@/utils/isempty';
  import { Toast } from 'vant';
  import { getExtraInfoDataApi, saveExtraInfoDataApi } from '../request/api';

  export default {
    name: 'extrainfo',
    components: { toptitle },
    data() {
      return {
        titlework: '额外信息填写',          // 顶部标题
        UUID: '',                           // 路由 query 参数（大写）
        userName: '',                       // 当前用户姓名（接口A返回）
        visibleTabs: [],                    // 可见页签 key 列表（根据返回 table 对象判断）
        activeNames: [],                    // 折叠面板展开项，默认全部收起

        // 页签 key 与标题映射
        tabMap: {
          noResign: '无离职证明承诺书',
          chemical: '化学-入职员工知识产权背景调查及自我声明',
          tpu: 'TPU-员工入职知识产权背景调查表',
          zhejiang: '浙江新材料+合成+重庆新材料-入职员工知识产权背景调查表'
        },

        // 选择器选项：是/否 → Y/N
        yesNoColumns: [
          { text: '是', value: 'Y' },
          { text: '否', value: 'N' }
        ],
        // 竞业限制补偿金倍数选项
        multipleColumns: [
          { text: '0～1倍', value: '0～1倍' },
          { text: '1-3倍', value: '1-3倍' },
          { text: '3倍以上', value: '3倍以上' }
        ],

        // 页签1：无离职证明承诺书 (C_PRE_JOB_TBL)
        formNoResign: {
          C_PRE_COMPANY: '',           // 上家单位名称
          C_END_DATE: ''              // 上家单位离职日期
        },

        // 页签2：化学-知识产权背景调查 (C_ZSCQ_HX_TBL)
        formChemical: {
          C_YJLY: '',                 // 研究领域
          workHistory: [              // C_PRECOM_HX_DT 数组
            { C_PRE_COMPANY: '', HR_NAME: '', HR_PHONE: '' }
          ],
          DESCRLONG: '',              // 知识产权情况介绍
          C_IS_BMYW: '',              // 是否保密义务 Y/N
          C_IS_JYXZ: '',              // 是否签署竞业限制 Y/N
          C_FLAG1: '',                // 是否执行竞业限制 Y/N
          COMMENTS: '',               // 竞业限制说明
          C_IS_CZJF: '',              // 是否存在知识产权纠纷 Y/N
          COMMENTS1: '',              // 知识产权纠纷说明
          C_IS_HCZSCQ: '',            // 是否允许核查 Y/N
          C_COMMENTS: ''              // 核查说明
        },

        // 页签3：TPU-知识产权背景调查 (C_ZSCQ_TPU_TBL)
        formTpu: {
          C_IS_FMZL: '',             // 发明专利 Y/N
          C_IS_SYXXZL: '',           // 实用新型专利 Y/N
          C_IS_WGZL: '',             // 外观专利 Y/N
          C_IS_JYXZ: '',             // 竞业限制 Y/N
          C_IS_CZJF: ''              // 知识产权纠纷 Y/N
        },

        // 页签4：新材料+合成-知识产权背景调查 (C_ZSCQ_XH_TBL)
        formZhejiang: {
          C_YJLY: '',                // 研究领域
          C_DESCR: '',               // 知识产权数量
          COMMENTS: '',              // 知识产权具体情况
          C_PRE_COMPANY: '',         // 公司名称
          C_COM_XZ: '',              // 公司性质
          C_ADDRESS: '',             // 公司地址
          BEGIN_DT: '',              // 开始日期（van-calendar range 拆分）
          END_DT: '',                // 结束日期
          C_PRE_DEPARTMENT: '',      // 就职部门
          NAME1: '',                 // 主管姓名
          DEPTID1_DESCR: '',         // 主管部门
          C_POSITION_DESCR1: '',     // 主管职位
          PHONE1: '',                // 主管电话
          NAME2: '',                 // HR姓名
          C_POSITION_DESCR2: '',     // HR职位
          PHONE2: '',                // HR电话
          C_TER_REASON: '',          // 离职原因
          C_IS_HCZSCQ: '',           // 是否允许核查 Y/N
          C_COMMENTS: '',            // 核查说明
          C_IS_CT: '',               // 因不正当行为被辞退 Y/N
          C_IS_BJDC: '',             // 未通过背景调查 Y/N
          C_IS_QXQX: '',             // 曾被取消进入权限 Y/N
          C_EXPLAIN: '',             // 情形解释
          C_IS_JYXZ: '',             // 竞业限制协议 Y/N
          C_FLAG1: '',               // 公司是否发放竞业限制补偿金 Y/N
          C_JYXZ_BS: '',             // 补偿金倍数
          C_JT_BS: '',               // 具体倍数（3倍以上时填写）
          C_IS_YXGZ: '',             // 是否了解其他竞业限制 Y/N
          C_XGXZ: ''                 // 相关限制
        },

        // 通用选择器状态
        picker: {
          show: false,
          title: '',
          columns: [],
          currentKey: ''              // 格式: 'formName.field'
        },

        // 离职日期选择器
        datePicker: { show: false },

        // 日期范围日历
        calendar: { show: false },

        // 日期范围日历最小可选日期（当前年份往前50年，不限制历史日期选择）
        calendarMinDate: new Date(new Date().getFullYear() - 50, 0, 1),

        // 日期范围日历最大可选日期（当前年份往后50年，不限制未来日期选择）
        calendarMaxDate: new Date(new Date().getFullYear() + 50, 11, 31),

        // 日期选择最大值（当前日期，用于离职日期选择器）
        maxDate: new Date(),

        // 是否已完成初始化（用于抑制接口回填时触发的清空提示）
        isInitialized: false,

        // 字段依赖规则配置（Rule 模式）：同时驱动「必填判断」与「级联清空」
        // condition: 'Y' 父字段为Y时必填 | 'N' 父字段为N时必填 | 'ANY_Y' 多个父字段任一为Y时必填 | 自定义字符串匹配
        // clearFields: 父字段不满足条件时需级联清空的字段（含自身及下游）
        dependencyRules: [
          // ===== 页签2 formChemical =====
          { field: 'formChemical.C_FLAG1', parents: ['formChemical.C_IS_JYXZ'], condition: 'Y',
            clearFields: ['formChemical.C_FLAG1', 'formChemical.COMMENTS'], groupLabel: '实际执行及说明' },
          { field: 'formChemical.COMMENTS', parents: ['formChemical.C_FLAG1'], condition: 'Y',
            clearFields: ['formChemical.COMMENTS'], groupLabel: '执行说明' },
          { field: 'formChemical.COMMENTS1', parents: ['formChemical.C_IS_CZJF'], condition: 'Y',
            clearFields: ['formChemical.COMMENTS1'], groupLabel: '纠纷说明' },
          { field: 'formChemical.C_COMMENTS', parents: ['formChemical.C_IS_HCZSCQ'], condition: 'N',
            clearFields: ['formChemical.C_COMMENTS'], groupLabel: '不允许原因' },
          // ===== 页签4 formZhejiang =====
          { field: 'formZhejiang.C_COMMENTS', parents: ['formZhejiang.C_IS_HCZSCQ'], condition: 'N',
            clearFields: ['formZhejiang.C_COMMENTS'], groupLabel: '不允许原因' },
          { field: 'formZhejiang.C_EXPLAIN',
            parents: ['formZhejiang.C_IS_CT', 'formZhejiang.C_IS_BJDC', 'formZhejiang.C_IS_QXQX'],
            condition: 'ANY_Y', clearFields: ['formZhejiang.C_EXPLAIN'], groupLabel: '情形解释' },
          { field: 'formZhejiang.C_FLAG1', parents: ['formZhejiang.C_IS_JYXZ'], condition: 'Y',
            clearFields: ['formZhejiang.C_FLAG1', 'formZhejiang.C_JYXZ_BS', 'formZhejiang.C_JT_BS'],
            groupLabel: '补偿金及倍数' },
          { field: 'formZhejiang.C_JYXZ_BS', parents: ['formZhejiang.C_FLAG1'], condition: 'Y',
            clearFields: ['formZhejiang.C_JYXZ_BS', 'formZhejiang.C_JT_BS'], groupLabel: '补偿金倍数' },
          { field: 'formZhejiang.C_JT_BS', parents: ['formZhejiang.C_JYXZ_BS'], condition: '3倍以上',
            clearFields: ['formZhejiang.C_JT_BS'], groupLabel: '具体倍数' },
          { field: 'formZhejiang.C_XGXZ', parents: ['formZhejiang.C_IS_YXGZ'], condition: 'Y',
            clearFields: ['formZhejiang.C_XGXZ'], groupLabel: '相关限制' }
        ],

        // 依赖字段的条件提示文案（展示在 label 中，说明何时必填）
        dependencyHints: {
          'formChemical.C_FLAG1': '签署竞业限制选"是"时必填',
          'formChemical.COMMENTS': '实际执行选"是"时必填',
          'formChemical.COMMENTS1': '存在纠纷选"是"时必填',
          'formChemical.C_COMMENTS': '不允许核查选"否"时必填',
          'formZhejiang.C_COMMENTS': '不允许核查选"否"时必填',
          'formZhejiang.C_EXPLAIN': '上述情形任一选"是"时必填',
          'formZhejiang.C_FLAG1': '签订竞业限制选"是"时必填',
          'formZhejiang.C_JYXZ_BS': '发放补偿金选"是"时必填',
          'formZhejiang.C_JT_BS': '倍数选"3倍以上"时必填',
          'formZhejiang.C_XGXZ': '了解其他限制选"是"时必填'
        }
      };
    },
    created() {
      // 初始化依赖监听器：父字段变化时自动级联清空子字段
      this.setupDependencyWatchers();
    },
    mounted() {
      this.UUID = this.$route.query.UUID || '';
      this.getUserInfo();
    },
    methods: {
      // ===== Y/N 展示转换 =====
      ynDisplay(val) {
        if (val === 'Y') return '是';
        if (val === 'N') return '否';
        return '';
      },

      // ===== 依赖关系核心方法（Rule 模式） =====
      // 通用取值（支持 'form.field' 两级路径）
      getFieldValue(key) {
        const keys = key.split('.');
        return this[keys[0]][keys[1]];
      },
      // 通用赋值（支持 'form.field' 两级路径）
      setFieldValue(key, value) {
        const keys = key.split('.');
        this[keys[0]][keys[1]] = value;
      },
      // 检查单条依赖规则的条件是否满足（决定子字段是否必填）
      checkCondition(rule) {
        if (rule.condition === 'ANY_Y') {
          // 任一父字段为 Y 即满足
          return rule.parents.some(p => this.getFieldValue(p) === 'Y');
        }
        // 父字段值匹配指定条件（'Y'/'N'/自定义值如 '3倍以上'）
        return rule.parents.some(p => this.getFieldValue(p) === rule.condition);
      },
      // 判断字段是否必填：有依赖规则则按条件判断，无规则默认必填
      isFieldRequired(fieldKey) {
        const rule = this.dependencyRules.find(r => r.field === fieldKey);
        if (!rule) return true;
        return this.checkCondition(rule);
      },
      // 生成依赖字段的标签：必填时显示基础标签，非必填时追加条件提示
      depLabel(baseLabel, fieldKey) {
        if (this.isFieldRequired(fieldKey)) return baseLabel;
        const hint = this.dependencyHints[fieldKey];
        return hint ? `${baseLabel}（${hint}）` : `${baseLabel}（非必填）`;
      },
      // 级联清空：将指定字段重置为空，并在初始化后给出提示
      clearFields(fieldKeys, groupLabel) {
        let cleared = false;
        fieldKeys.forEach(k => {
          if (this.getFieldValue(k)) {
            this.setFieldValue(k, '');
            cleared = true;
          }
        });
        // 仅在用户主动操作阶段（非接口回填）提示
        if (cleared && this.isInitialized && groupLabel) {
          this.$toast(`已重置${groupLabel}`);
        }
      },
      // 初始化依赖监听器：遍历规则，为每个父字段注册 watcher
      // 父字段变化且条件不再满足时，自动清空关联子字段
      setupDependencyWatchers() {
        this.dependencyRules.forEach(rule => {
          rule.parents.forEach(parentKey => {
            this.$watch(parentKey, () => {
              if (!this.checkCondition(rule)) {
                this.clearFields(rule.clearFields, rule.groupLabel);
              }
            });
          });
        });
      },

      // ===== 接口A：获取用户信息和页签信息 =====
      getUserInfo() {
        getExtraInfoDataApi({ UUID: this.UUID }).then(res => {
          if (res.CODE === 200) this.handleUserInfo(res.DATA);
        });
      },
      // 处理接口A返回数据：按 table 对象存在判断页签可见，赋值表单
      handleUserInfo(data) {
        this.userName = data.NAME || '';
        const tabs = [];
        if (data.C_PRE_JOB_TBL) {
          tabs.push('noResign');
          this.formNoResign.C_PRE_COMPANY = data.C_PRE_JOB_TBL.C_PRE_COMPANY || '';
          this.formNoResign.C_END_DATE = data.C_PRE_JOB_TBL.C_END_DATE || '';
        }
        if (data.C_ZSCQ_HX_TBL) {
          tabs.push('chemical');
          const hx = data.C_ZSCQ_HX_TBL;
          this.formChemical.C_YJLY = hx.C_YJLY || '';
          this.formChemical.DESCRLONG = hx.DESCRLONG || '';
          this.formChemical.C_IS_BMYW = hx.C_IS_BMYW || '';
          this.formChemical.C_IS_JYXZ = hx.C_IS_JYXZ || '';
          this.formChemical.C_FLAG1 = hx.C_FLAG1 || '';
          this.formChemical.COMMENTS = hx.COMMENTS || '';
          this.formChemical.C_IS_CZJF = hx.C_IS_CZJF || '';
          this.formChemical.COMMENTS1 = hx.COMMENTS1 || '';
          this.formChemical.C_IS_HCZSCQ = hx.C_IS_HCZSCQ || '';
          this.formChemical.C_COMMENTS = hx.C_COMMENTS || '';
          if (hx.C_PRECOM_HX_DT && hx.C_PRECOM_HX_DT.length) {
            this.formChemical.workHistory = hx.C_PRECOM_HX_DT.map(item => ({
              C_PRE_COMPANY: item.C_PRE_COMPANY || '',
              HR_NAME: item.HR_NAME || '',
              HR_PHONE: item.HR_PHONE || ''
            }));
          }
        }
        if (data.C_ZSCQ_TPU_TBL) {
          tabs.push('tpu');
          const tpu = data.C_ZSCQ_TPU_TBL;
          this.formTpu.C_IS_FMZL = tpu.C_IS_FMZL || '';
          this.formTpu.C_IS_SYXXZL = tpu.C_IS_SYXXZL || '';
          this.formTpu.C_IS_WGZL = tpu.C_IS_WGZL || '';
          this.formTpu.C_IS_JYXZ = tpu.C_IS_JYXZ || '';
          this.formTpu.C_IS_CZJF = tpu.C_IS_CZJF || '';
        }
        if (data.C_ZSCQ_XH_TBL) {
          tabs.push('zhejiang');
          const xh = data.C_ZSCQ_XH_TBL;
          const keys = ['C_YJLY','C_DESCR','COMMENTS','C_PRE_COMPANY','C_COM_XZ','C_ADDRESS',
            'BEGIN_DT','END_DT','C_PRE_DEPARTMENT','NAME1','DEPTID1_DESCR','C_POSITION_DESCR1',
            'PHONE1','NAME2','C_POSITION_DESCR2','PHONE2','C_TER_REASON','C_IS_HCZSCQ',
            'C_COMMENTS','C_IS_CT','C_IS_BJDC','C_IS_QXQX','C_EXPLAIN','C_IS_JYXZ',
            'C_FLAG1','C_JYXZ_BS','C_JT_BS','C_IS_YXGZ','C_XGXZ'];
          keys.forEach(k => { if (xh[k] !== undefined) this.formZhejiang[k] = xh[k]; });
        }
        this.visibleTabs = tabs;
        // 接口回填完成后再开启提示，避免初始化赋值触发清空 toast
        this.$nextTick(() => { this.isInitialized = true; });
      },

      // ===== 通用选择器（是/否、倍数等）复用 =====
      openPicker(key, title, columns = this.yesNoColumns) {
        this.picker.currentKey = key;
        this.picker.title = title;
        this.picker.columns = columns;
        this.picker.show = true;
      },
      // 选择器确认：从选项对象取 value，通过统一方法赋值（会触发依赖监听器）
      onPickerConfirm(option) {
        const value = typeof option === 'object' ? (option.value || option.text) : option;
        this.setFieldValue(this.picker.currentKey, value);
        this.picker.show = false;
      },

      // ===== 历史工作经历增删 =====
      addWorkHistory() {
        this.formChemical.workHistory.push({ C_PRE_COMPANY: '', HR_NAME: '', HR_PHONE: '' });
      },
      removeWorkHistory(index) {
        this.formChemical.workHistory.splice(index, 1);
      },

      // ===== 日期处理 =====
      onResignDateConfirm(date) {
        this.formNoResign.C_END_DATE = this.formatDate(date);
        this.datePicker.show = false;
      },
      onDateRangeConfirm(date) {
        this.formZhejiang.BEGIN_DT = this.formatDate(date[0]);
        this.formZhejiang.END_DT = this.formatDate(date[1]);
        this.calendar.show = false;
      },
      formatDate(date) {
        if (!date) return '';
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const d = date.getDate().toString().padStart(2, '0');
        return `${y}-${m}-${d}`;
      },
      formatDateRange() {
        if (!this.formZhejiang.BEGIN_DT && !this.formZhejiang.END_DT) return '';
        return `${this.formZhejiang.BEGIN_DT || ''} ~ ${this.formZhejiang.END_DT || ''}`;
      },

      // ===== 必填校验（仅校验可见页签，依赖字段按 isFieldRequired 动态判断） =====
      validate() {
        // 页签1（无依赖，全部必填）
        if (this.visibleTabs.includes('noResign')) {
          if (isempty(this.formNoResign.C_PRE_COMPANY)) { this.$toast('请填写上家单位名称'); return false; }
          if (isempty(this.formNoResign.C_END_DATE)) { this.$toast('请选择上家单位离职日期'); return false; }
        }
        // 页签2
        if (this.visibleTabs.includes('chemical')) {
          if (isempty(this.formChemical.C_YJLY)) { this.$toast('请填写研究领域'); return false; }
          for (let i = 0; i < this.formChemical.workHistory.length; i++) {
            const item = this.formChemical.workHistory[i];
            if (isempty(item.C_PRE_COMPANY)) { this.$toast(`请填写第${i + 1}条经历的曾入职前单位`); return false; }
            if (isempty(item.HR_NAME)) { this.$toast(`请填写第${i + 1}条经历的前单位人事联系人`); return false; }
            if (isempty(item.HR_PHONE)) { this.$toast(`请填写第${i + 1}条经历的联系号码`); return false; }
          }
          if (isempty(this.formChemical.DESCRLONG)) { this.$toast('请填写知识产权情况介绍'); return false; }
          if (isempty(this.formChemical.C_IS_BMYW)) { this.$toast('请选择是否存在保密义务'); return false; }
          if (isempty(this.formChemical.C_IS_JYXZ)) { this.$toast('请选择是否签署竞业限制条款'); return false; }
          // C_FLAG1：签署竞业限制选"是"时必填
          if (this.isFieldRequired('formChemical.C_FLAG1') && isempty(this.formChemical.C_FLAG1)) { this.$toast('请选择是否有实际执行'); return false; }
          // COMMENTS：实际执行选"是"时必填
          if (this.isFieldRequired('formChemical.COMMENTS') && isempty(this.formChemical.COMMENTS)) { this.$toast('请填写执行说明'); return false; }
          if (isempty(this.formChemical.C_IS_CZJF)) { this.$toast('请选择是否存在知识产权纠纷'); return false; }
          // COMMENTS1：存在纠纷选"是"时必填
          if (this.isFieldRequired('formChemical.COMMENTS1') && isempty(this.formChemical.COMMENTS1)) { this.$toast('请填写纠纷说明'); return false; }
          if (isempty(this.formChemical.C_IS_HCZSCQ)) { this.$toast('请选择是否允许核查'); return false; }
          // C_COMMENTS：不允许核查选"否"时必填
          if (this.isFieldRequired('formChemical.C_COMMENTS') && isempty(this.formChemical.C_COMMENTS)) { this.$toast('请填写不允许原因'); return false; }
        }
        // 页签3（无依赖，全部必填）
        if (this.visibleTabs.includes('tpu')) {
          if (isempty(this.formTpu.C_IS_FMZL)) { this.$toast('请选择是否有发明专利'); return false; }
          if (isempty(this.formTpu.C_IS_SYXXZL)) { this.$toast('请选择是否有实用新型专利'); return false; }
          if (isempty(this.formTpu.C_IS_WGZL)) { this.$toast('请选择是否有外观专利'); return false; }
          if (isempty(this.formTpu.C_IS_JYXZ)) { this.$toast('请选择是否签署竞业尽职限制协议'); return false; }
          if (isempty(this.formTpu.C_IS_CZJF)) { this.$toast('请选择是否发生过知识产权纠纷'); return false; }
        }
        // 页签4
        if (this.visibleTabs.includes('zhejiang')) {
          const f = this.formZhejiang;
          if (isempty(f.C_YJLY)) { this.$toast('请填写研究领域'); return false; }
          if (isempty(f.C_DESCR)) { this.$toast('请填写知识产权数量'); return false; }
          if (isempty(f.COMMENTS)) { this.$toast('请填写知识产权具体情况'); return false; }
          if (isempty(f.C_PRE_COMPANY)) { this.$toast('请填写公司名称'); return false; }
          if (isempty(f.C_COM_XZ)) { this.$toast('请填写公司性质'); return false; }
          if (isempty(f.C_ADDRESS)) { this.$toast('请填写公司地址'); return false; }
          if (isempty(f.BEGIN_DT) || isempty(f.END_DT)) { this.$toast('请选择起始时间范围'); return false; }
          if (isempty(f.C_PRE_DEPARTMENT)) { this.$toast('请填写就职部门'); return false; }
          if (isempty(f.NAME1)) { this.$toast('请填写直接主管姓名'); return false; }
          if (isempty(f.DEPTID1_DESCR)) { this.$toast('请填写直接主管部门'); return false; }
          if (isempty(f.C_POSITION_DESCR1)) { this.$toast('请填写直接主管职位'); return false; }
          if (isempty(f.PHONE1)) { this.$toast('请填写直接主管电话'); return false; }
          if (isempty(f.NAME2)) { this.$toast('请填写人力资源联系人姓名'); return false; }
          if (isempty(f.C_POSITION_DESCR2)) { this.$toast('请填写人力资源联系人职位'); return false; }
          if (isempty(f.PHONE2)) { this.$toast('请填写人力资源联系人电话'); return false; }
          if (isempty(f.C_TER_REASON)) { this.$toast('请填写离职原因'); return false; }
          if (isempty(f.C_IS_HCZSCQ)) { this.$toast('请选择是否允许核查'); return false; }
          // C_COMMENTS：不允许核查选"否"时必填
          if (this.isFieldRequired('formZhejiang.C_COMMENTS') && isempty(f.C_COMMENTS)) { this.$toast('请填写不允许原因'); return false; }
          if (isempty(f.C_IS_CT)) { this.$toast('请选择是否因不正当行为被辞退'); return false; }
          if (isempty(f.C_IS_BJDC)) { this.$toast('请选择是否未通过背景调查'); return false; }
          if (isempty(f.C_IS_QXQX)) { this.$toast('请选择是否曾被取消进入公司设施权限'); return false; }
          // C_EXPLAIN：上述情形任一选"是"时必填
          if (this.isFieldRequired('formZhejiang.C_EXPLAIN') && isempty(f.C_EXPLAIN)) { this.$toast('请填写情形解释'); return false; }
          if (isempty(f.C_IS_JYXZ)) { this.$toast('请选择是否签订竞业限制协议'); return false; }
          // C_FLAG1：签订竞业限制选"是"时必填
          if (this.isFieldRequired('formZhejiang.C_FLAG1') && isempty(f.C_FLAG1)) { this.$toast('请选择公司是否发放竞业限制补偿金'); return false; }
          // C_JYXZ_BS：发放补偿金选"是"时必填
          if (this.isFieldRequired('formZhejiang.C_JYXZ_BS') && isempty(f.C_JYXZ_BS)) { this.$toast('请选择补偿金倍数'); return false; }
          // C_JT_BS：倍数选"3倍以上"时必填
          if (this.isFieldRequired('formZhejiang.C_JT_BS') && isempty(f.C_JT_BS)) { this.$toast('请填写具体倍数'); return false; }
          if (isempty(f.C_IS_YXGZ)) { this.$toast('请选择是否了解其他竞业限制协议'); return false; }
          // C_XGXZ：了解其他限制选"是"时必填
          if (this.isFieldRequired('formZhejiang.C_XGXZ') && isempty(f.C_XGXZ)) { this.$toast('请填写相关限制'); return false; }
        }
        return true;
      },

      // ===== 组装保存参数（嵌套结构，复用查询返回结构） =====
      buildSaveParams() {
        const params = { UUID: this.UUID };
        if (this.visibleTabs.includes('noResign')) {
          params.C_PRE_JOB_TBL = { ...this.formNoResign };
        }
        if (this.visibleTabs.includes('chemical')) {
          params.C_ZSCQ_HX_TBL = {
            C_YJLY: this.formChemical.C_YJLY,
            C_PRECOM_HX_DT: this.formChemical.workHistory,
            DESCRLONG: this.formChemical.DESCRLONG,
            C_IS_BMYW: this.formChemical.C_IS_BMYW,
            C_IS_JYXZ: this.formChemical.C_IS_JYXZ,
            C_FLAG1: this.formChemical.C_FLAG1,
            COMMENTS: this.formChemical.COMMENTS,
            C_IS_CZJF: this.formChemical.C_IS_CZJF,
            COMMENTS1: this.formChemical.COMMENTS1,
            C_IS_HCZSCQ: this.formChemical.C_IS_HCZSCQ,
            C_COMMENTS: this.formChemical.C_COMMENTS
          };
        }
        if (this.visibleTabs.includes('tpu')) {
          params.C_ZSCQ_TPU_TBL = { ...this.formTpu };
        }
        if (this.visibleTabs.includes('zhejiang')) {
          params.C_ZSCQ_XH_TBL = { ...this.formZhejiang };
        }
        return params;
      },

      // ===== 保存：校验通过后提交 =====
      save() {
        if (!this.validate()) return;
        const params = this.buildSaveParams();
        saveExtraInfoDataApi(params).then(res => {
          if (res.CODE === 200) {
            Toast.success('保存成功');
            this.getUserInfo();
          } else {
            Toast.fail(res.MESSAGE);
          }
        });
      }
    }
  };
</script>

<style lang="less" scoped>
  .extrainfo {
    padding-bottom: 60px;
  }
  .user-info {
    padding: 10px 16px;
    font-size: 14px;
    color: #323233;
    background: #fff;
    border-bottom: 1px solid #f5f5f5;
  }
  .text-tip {
    padding: 12px 16px 4px;
    font-size: 14px;
    color: #646566;
    font-weight: 500;
  }
  .sub-block {
    margin-top: 8px;
    .sub-block-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
      font-size: 14px;
      color: #323233;
      font-weight: 500;
    }
    .sub-block-item {
      margin: 0 8px 8px;
      border: 1px solid #f0f0f0;
      border-radius: 6px;
      overflow: hidden;
    }
    .sub-block-item-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 12px;
      background: #fafafa;
      font-size: 13px;
      color: #646566;
    }
    .indent-block {
      margin: 0 16px;
      border-left: 3px solid #007fc6;
    }
  }
  .footer-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px 16px;
    background: #fff;
    box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.06);
    z-index: 10;
  }
  /* 非必填依赖字段视觉弱化：降低文字透明度 */
  .field-optional ::v-deep .van-field__label,
  .field-optional ::v-deep .van-field__control {
    color: #969799;
  }
  .field-optional ::v-deep .van-cell__required-dot {
    display: none;
  }
</style>
